import { Modal, Box, IconButton } from '@mui/material';
import styled from 'styled-components';


export const StyledModal = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ModalContent = styled(Box)`
    background: white;
    padding: 0;
    border-radius: 10px;
    position: relative;
    text-align: center;
    max-width: 440px;
    width: 100%;
    @media (max-width: 460px){
        width: 90%;        
    }
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    top: -205px;
    right: -175px;
    color: white !important;
    font-size: 20px;
    z-index: 3; 
    @media (max-width: 460px){
        right: -150px;        
    } 
`;

export const ImageContainer = styled.div`
    width: 100%;
    height: 200px;
    overflow: hidden;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: relative; 
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const Line = styled.div`
    height: 5px; 
    background-color: rgb(168, 0, 0); 
    width: 100%;
    margin-top:-1px;
`;

export const Content = styled.div`
    padding: 20px;
`;